var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home_container"
  }, [_c('my-swiper', {
    ref: "topSwiper",
    attrs: {
      "list": (_vm._i18n.locale == 'zh' ? _vm.loopList : _vm.loopListEn)
    }
  }), _vm._v(" "), _c('expo-msg', {
    ref: "contentRef"
  }), _vm._v(" "), _c('page-footer')], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26ecc787","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/index.vue
// module id = null
// module chunks = 